import { styled, TableCell, tableCellClasses } from "@mui/material";

export const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "3%",
    padding: "1% 0 0 0",
    border: "none"
  },
}));

export const StyledTableCellFooter = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "4%",
    padding: "1% 0",
    border: "none"
  },
}));

export const StyledTableCellTrialDays = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "13%",
    padding: "1% 0 0 0",
    border: "none"
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "10%",
    padding: "1% 0 0 0",
    border: "none"
  },
}));

export const StyledTableCellRole = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "12%",
    padding: "1% 0",
    border: "none"
  },
}));

export const StyledTableCellMail = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "20%",
    padding: "1% 0 0 0",
    border: "none"
  },
}));

export const StyledTableCellAutocomplete = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "17%",
    padding: "1% 0",
    border: "none"
  },
}));
